import FreelancersV2 from "./freelancers/FreelancersV2";

/** Listagem de freelancers (server-side). A V1 (cache client-side) foi removida. */
export default function Freelancers() {
  return <FreelancersV2 />;
}
